<!--
 * @Description: 任务汇总。 与OSS不一样
 * @Date: 2021-10-29 11:26:11
-->
<template>
  <div class="table-box">
    <div class="search-box">
      <div class="search-left">
        <TableSearch v-model="searchQuery" />
      </div>
      <div class="search-right flex-start" style="margin-bottom:10px;">
        <el-button type="primary" @click="searchEvent">搜索</el-button>
        <TableTopHandler />
      </div>
    </div>
    <!--列表-->
    <div class>
      <el-table
        v-loading="loading"
        :data="tableData"
        border
        height="75vh"
        style="width: 100%"
        :stripe="true"
        :highlight-current-row="false"
        :row-class-name="
          ({ row, rowIndex }) =>
            getUnqualifiedRowConfig({
              row: row,
              rowIndex: rowIndex,
              isNotUnqualified: isNotUnqualified(row)
            })
        "
      >
        <template v-for="(item, index) in taskRecordMixin_fields">
          <template>
            <TableField :item="item" :index="index" :key="item.prop" />
          </template>
        </template>
        <TableHandler />
      </el-table>
      <!--分页-->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[15, 60, 100]"
        :current-page="paginationData.pageNum"
        :total="totalElements"
        :page-size="paginationData.pageSize"
        layout="total, prev, pager, next, sizes, jumper"
        style="padding:15px"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { taskRecordSummary } from '../../api';
import { pageInation } from '@/Mixin/listMixin';
import taskSumMixin from './mixins/index.js';
import { getUnqualifiedRowConfig } from '@/methods/unqualified';

export default {
  name: 'task-summary',
  mixins: [pageInation, taskSumMixin],
  data() {
    return {
      getUnqualifiedRowConfig,
      paginationData: {
        //提交分页数据
        pageNo: 1, // 当前页
        pageSize: 60 // 每页显示条
      },
      getList: taskRecordSummary.list, // 获取列表的AJAX
      searchQuery: {
        superviseStatus: 1,
        projectId: '',
        userName: '',
        fullName: '',
        phone: '',
        projectType: '',
        userTag: '',
        isSettlement: 1
      }
    };
  },
  methods: {
    isNotUnqualified(row) {
      return !(
        ('superviseStatus' in row && row.superviseStatus === 3) ||
        row.zbBlackStatus === 2
      );
    }
  },
  created() {
    const { id: projectId, projectType } = this.$store.state.homeProject;
    const {
      id: _id,
      projectType: _projectType,
      ...options
    } = this.$route.query;
    this.searchQuery = {
      ...this.searchQuery,
      projectId,
      projectType,
      ...options
    };
  }
};
</script>
<style lang="scss" scoped>
.search-right.flex-start {
  align-items: flex-start;
}
</style>
